module.exports = __webpack_public_path__ + "static/media/blog-2.97a8064f.jpg";